"use client";
import { jsxs as r, Fragment as d, jsx as t } from "react/jsx-runtime";
import { COLOR_SEVERITY as f } from "../../constants/colorSeverity.js";
import { ICON_SEVERITY as s } from "../../constants/iconSeverity.js";
import c from "../../../components/icon/Icon.js";
import l from "../../../components/text/Text.js";
import n from "@emotion/styled";
import { SPACINGS as x } from "../../../tokens/spacings/Spacings.js";
import { forwardRef as I } from "react";
const g = I(
  ({ children: i, feCharCounter: m, feSeverity: o, feSize: a = "md", ...e }, p) => /* @__PURE__ */ r(u, { "data-comp": "input-meta", children: [
    i && /* @__PURE__ */ r(d, { children: [
      o && /* @__PURE__ */ t(
        c,
        {
          feColor: s[o].colorAlias,
          feIcon: s[o].iconAlias
        }
      ),
      /* @__PURE__ */ t(
        l,
        {
          ...e,
          "aria-live": "polite",
          as: "p",
          ref: p,
          feColor: o && f[o].alias,
          feFontSize: a === "sm" ? "xs" : "sm",
          feLineHeight: "md",
          children: i
        }
      )
    ] }),
    m && /* @__PURE__ */ t(C, { as: "div", feColor: "gray500", feFontSize: a === "sm" ? "xs" : "sm", children: m })
  ] })
);
g.displayName = "Hint";
const u = n.div`
	align-items: flex-start;
	display: flex;
	gap: ${x.xxs};
`, C = n(l)`
	margin-inline-start: auto;
`;
export {
  g as default
};
